import React from 'react';

export default function Footer() {
  return (
    <footer className="max-w-md mx-auto px-6 pb-60 pt-10 text-center print-hide">
      <div className="flex justify-center gap-4 mb-4">
        <a 
          href="https://cafe.naver.com/f-e/cafes/30029518/menus/203" 
          target="_blank" 
          rel="noreferrer" 
          className="text-[11px] font-bold text-gray-400 hover:text-indigo-500 transition-colors flex items-center gap-1"
        >
          공지사항 및 업데이트
        </a>
      </div>
      <div className="flex justify-center gap-4 mb-4">
        <a 
          href="https://cyclic-august-042.notion.site/380c7ac726c080c9a090fd955874d078?source=copy_link" 
          target="_blank" 
          rel="noreferrer" 
          className="text-[11px] font-bold text-gray-400 hover:text-indigo-500 transition-colors flex items-center gap-1"
        >
          <span className="material-icons-round text-sm">check_circle</span>
          이용약관
        </a>
        <a 
          href="https://cyclic-august-042.notion.site/35dc7ac726c080308d2df4534803081a?source=copy_link" 
          target="_blank" 
          rel="noreferrer" 
          className="text-[11px] font-bold text-gray-400 hover:text-indigo-500 transition-colors flex items-center gap-1"
        >
          <span className="material-icons-round text-sm">policy</span>
          개인정보처리방침
        </a>
        <span className="text-gray-200 text-[10px]">|</span>
        <span className="text-[11px] font-bold text-gray-300">© 2026 벌키</span>
      </div>
      <div className="flex justify-center gap-4 mb-4">
        <span className="text-[11px] font-bold text-gray-400 hover:text-indigo-500 transition-colors flex items-center gap-1">
          Contact | afzxc@naver.com
        </span>
      </div>
      {/* <p className="text-[10px] text-gray-400 leading-relaxed px-4">
        본 서비스는 별도의 서버 저장을 하지 않으며,<br /> 
        모든 운동 데이터는 사용자의 기기에 안전하게 보관됩니다.
      </p> */}
    </footer>
  );
}